import makeStyles from '@mui/styles/makeStyles';

import {
  borderColor,
  darkGray,
  surfaceElevated,
  surfaceSecondary,
  teal900,
  textPrimary,
} from '@/theme/colors';

export const useStyles = makeStyles({
  formContent: {
    padding: '16px 24px',
    backgroundColor: surfaceElevated,
  },
  welcomeBanner: {
    backgroundColor: '#F0FDFA',
    border: '1px solid #99F6E4',
    borderRadius: 8,
    padding: 12,
    textAlign: 'center',
    marginBottom: 20,
  },
  welcomeTitle: {
    fontSize: 14,
    color: '#0F766E',
    margin: 0,
  },
  welcomeName: {
    fontWeight: 600,
  },
  welcomeCompany: {
    fontSize: 12,
    color: '#0D9488',
    marginTop: 2,
  },
  instructions: {
    fontSize: 14,
    color: darkGray,
    textAlign: 'center',
    margin: '0 0 16px 0',
    '& .address': {
      fontWeight: 500,
      color: textPrimary,
    },
  },
  codeLabel: {
    textAlign: 'center',
    fontSize: 14,
    color: darkGray,
    marginBottom: 12,
  },
  codeInputContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 10,
    marginBottom: 16,
  },
  codeInput: {
    width: 44,
    height: 52,
    border: `1px solid ${borderColor}`,
    borderRadius: 4,
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 600,
    outline: 'none',
    caretColor: teal900,
    '&:focus': {
      borderColor: teal900,
      boxShadow: `0 0 0 1px ${teal900}`,
    },
    '&:disabled': {
      backgroundColor: surfaceSecondary,
      cursor: 'not-allowed',
    },
  },
  codeInputError: {
    borderColor: '#DC2626',
    '&:focus': {
      borderColor: '#DC2626',
      boxShadow: '0 0 0 1px #DC2626',
    },
  },
  resendSection: {
    textAlign: 'center',
    marginTop: 16,
  },
  resendButton: {
    fontSize: 14,
    color: 'var(--brandPrimary)',
    cursor: 'pointer',
    textDecoration: 'none',
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:disabled': {
      color: '#9CA3AF',
      cursor: 'not-allowed',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
  cooldownText: {
    fontSize: 14,
    color: '#9CA3AF',
  },
  notYouSection: {
    textAlign: 'center',
    marginTop: 16,
  },
  notYouText: {
    fontSize: 12,
    color: darkGray,
  },
  notYouLink: {
    fontSize: 12,
    color: 'var(--brandPrimary)',
    cursor: 'pointer',
    textDecoration: 'underline',
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    marginLeft: 4,
    '&:hover': {
      color: 'var(--brandPrimaryHover)',
    },
  },
  errorMessage: {
    backgroundColor: '#FEF2F2',
    border: '1px solid #FECACA',
    borderRadius: 4,
    padding: 12,
    marginBottom: 16,
    textAlign: 'center',
  },
  errorText: {
    fontSize: 14,
    color: '#DC2626',
    margin: 0,
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 24px',
    borderTop: `1px solid ${borderColor}`,
    backgroundColor: surfaceSecondary,
  },
  backButton: {
    color: 'var(--brandPrimary)',
    fontSize: 12,
    fontWeight: 500,
    textTransform: 'uppercase',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 8,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  verifyButton: {
    backgroundColor: teal900,
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
    padding: '10px 24px',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: '#004544',
    },
    '&:disabled': {
      backgroundColor: '#D1D5DB',
      color: '#9CA3AF',
      cursor: 'not-allowed',
    },
  },
});
